import request from '@/utils/request'

//获取顶部导航栏菜单列表
export function getListMenu(){
  return request({
    url: '/web/merchant/listMenu',
    method: 'post',
  })
};

//视频
export function getListHome(){
  return request({
    url: '/web/merchant/listHome',
    method: 'post',
  })
};

export function getListAbout(){
  return request({
    url: '/web/merchant/listAbout',
    method: 'post',
  })
};
export function getListService(){
  return request({
    url: '/web/merchant/listServices',
    method: 'get',
  })
};
export function getListProducts(){
  return request({
    url: '/web/merchant/listProducts',
    method: 'get',
  })
};
export function getListNews(){
  return request({
    url: '/web/merchant/listNews',
    method: 'get',
  })
};
export function getListContacts(){
  return request({
    url: '/web/merchant/listContacts',
    method: 'get',
  })
};
export function addContact(data){
  return request({
    url: '/web/merchant/addContact',
    method: 'post',
    data:data
  })
};
export function getContactsMeList(){
  return request({
    url: '/web/merchant/listContactsMeList',
    method: 'post',
  })
};
export function getListFacilities(){
  return request({
    url: '/web/merchant/listFacilities',
    method: 'post',
  })
};



// WEBPACK FOOTER //
// ./src/api/home.js